import * as React from "react";
import Box from "@mui/material/Box";
import {  Typography, FormControl, Button, Divider, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useStoreActions } from "easy-peasy";
import api from "../../../services/api";
import {
  Checkbox,
  TextField,
  Autocomplete,
  OrderList,
} from "../../../components";
import {
  optionsDefTemas,
  optionsFequenciaPercepcao,
  optionsPercepImplementa,
  optionsQntdTemasTrab,
  optionsResultPercep,
  optionsTemas,
  optionsEstagioPlano
} from "./statics";

const Registros = ({ ano, empresa }) => {
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const schema = yup.object({
    freqPesqPercep: yup.number().positive().nullable().label('pesquisa'),
    percepImplementacao: yup.number().positive().nullable().label('quando'),
    indicadorConfianca: yup
      .boolean()
      .label("Confiança"),
    indicadorFavorabilidade: yup
      .boolean()
      .label("Favorabilidade"),
    indicadorImagem: yup.boolean().label("Imagem"),
    indicadorLicenca: yup
      .boolean()
      .label("Licença"),
    indicadorReputacao: yup
      .boolean()
      .label("Reputação"),
    indicadorSatisfacao: yup
      .boolean()
      .label("Satisfação"),
    indicadorOutro: yup.string().nullable().label('outro'),
    resultadoPesqPercep: yup.number().positive().nullable().label('resultado'),
    mapeamentoTemas: yup
      .boolean()
      .label(
        "A minha empresa possui mapeamento dos temas prioritários para as comunidades dos territórios de atuação da sua empresa."
      ),
    temaMetodolUtilizadas: yup
      .string()
      .nullable()
      .max(1000, 'Máximo 1000 caracteres')
      .label('metodologia'),
    definicaoTemas: yup.number().positive().nullable().label('definição temas'),
    consultorias: yup
      .string()
      .nullable()
      .max(1000, 'Máximo 1000 caracteres')
      .label('consultorias'),
    ordemTemas: yup.array().nullable().label('Ordem temas'),
    qntdTemasTrab: yup.string().nullable().label('Uso dos temas'),
    ferramentaMensurarSatisf: yup
      .boolean()
      .label(
        "A minha empresa possui ferramenta para mensuração de indicador de satisfação."
      ),
    ferramentaDetalhamento: yup
      .string()
      .max(1000, 'Máximo 1000 caracteres')
      .label("Por favor, detalhe a metodologia usada")
      .nullable(),
    planoFechamentoMina: yup
      .boolean()
      .label(
        "A minha empresa possui Plano de Fechamento de Mina incluindo plano social e/ou de transição social e uso futuro."
      ),
    planoFechamentoMinaComent: yup
      .string()
      .max(1000, 'Máximo 1000 caracteres')
      .label("Comentário")
      .nullable(),
    estagioPlanoFechamento: yup.number().positive().nullable().label('estágio'),
    metodologiaEstagioPlano: yup
      .string()
      .max(1000, 'Máximo 1000 caracteres')
      .label(
        "Por favor, detalhe a metodologia usada"
      )
      .nullable(),
    observacoes: yup
      .string()
      .max(1000, 'Máximo 1000 caracteres')
      .label(
        "Deixe seu comentário ou outras informações que considerar importante"
      )
      .nullable(),
  }).required();

  const useFormRef = useForm({
    mode: "onTouched",
    resolver: yupResolver(schema),
  });

  const {
    handleSubmit,
    reset,
    watch,
    formState: { isDirty, isSubmitting },
  } = useFormRef;

  const freqPerc = watch("freqPesqPercep");
  const mapeaTemas = watch("mapeamentoTemas");
  const mensuraSatisf = watch("ferramentaMensurarSatisf");
  const mensuraPlanoFechMina = watch("planoFechamentoMina");
  const defTemas = watch("definicaoTemas");

  const disabledFeqPerc = () => {
    return freqPerc === null;
  };
  const disabledMapeaTemas = () => {
    return !mapeaTemas;
  };
  const disabledMensuraSatisf = () => {
    return !mensuraSatisf;
  };
  const disabledPlanoFechMinaComent = () => {
    return !mensuraPlanoFechMina;
  };
  const disabledDefTemas = () => {
    return defTemas !== 2;
  };

  const loadRegistros = async (mount) => {
    startLoading();
    try {
      let url = "06/registros/empresa/" + empresa + "/" + ano;
      let getRegistros = await api.http.get(url);
      if (mount.isMounted) {
          reset(getRegistros.data);
      }
      stopLoading();
    } catch (error) {
      if(error.response && error.response.status===404) {
        if(mount.isMounted) {
          reset({
            ano: ano,
            freqPesqPercep: null,
            indicadorConfianca: false,
            indicadorFavorabilidade: false,
            indicadorImagem: false,
            indicadorLicenca: false,
            indicadorReputacao: false,
            indicadorSatisfacao: false,
            indicadorOutro: null,
            percepImplementacao: null,
            resultadoPesqPercep: null,
            mapeamentoTemas: false,
            temaMetodolUtilizadas: null,
            definicaoTemas: null,
            consultorias: null,
            ordemTemas: optionsTemas.map((option) => option.id),
            qntdTemasTrab: null,
            ferramentaMensurarSatisf: false,
            ferramentaDetalhamento: null,
            planoFechamentoMina: false,
            planoFechamentoMinaComent: null,
            estagioPlanoFechamento: null,
            metodologiaEstagioPlano: null,
            observacoes: null
          });
        }
        stopLoading();
      } else {
        stopLoading({
          message: error.toString(),
          severity: "error",
        });
      }
    }
  };

  const submit = async (data) => {
    startLoading();
    try {
      let result;
      if (data.id) {
        result = await api.http.put(
          "06/registros/empresa/" + empresa + "/" + data.id,
          { ...data }
        );
      } else {
        result = await api.http.post("06/registros/empresa/" + empresa, {
          ...data,
          ano: ano,
        });
      }
      reset(result.data);
      stopLoading({ severity: "success" });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true,
    };
    loadRegistros(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [ano, empresa]);

  return (
    (<div>
      <Divider>
        <h3>Percepção</h3>
      </Divider>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        '& .MuiTypography-root': {  textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
       }}>
         <Grid
           size={{
             md: 7
           }}>
         <Typography>
           Com que frequência a sua empresa realiza pesquisa de percepção da
           comunidade sobre a sua atuação nos territórios?
         </Typography>
         </Grid>
       <Grid
         size={{
           md: 5
         }}>
         <FormControl fullWidth>
       <Autocomplete
         field="freqPesqPercep"
         options={optionsFequenciaPercepcao}
         schema={schema}
         useFormRef={useFormRef}
       />
       </FormControl>
     </Grid>
     <Grid
       size={{
         md: 7
       }}>
       <Typography>Quando foi implementada?</Typography>
       </Grid>
       <Grid
         size={{
           md: 5
         }}>
        <FormControl fullWidth>
         <Autocomplete
           field="percepImplementacao"
           options={optionsPercepImplementa}
           schema={schema}
           useFormRef={useFormRef}
           disabled={disabledFeqPerc()}
           />
       </FormControl>
     </Grid>
     </Grid>
      <p>
        Qual(is) indicador(es) é(são) medido(s) pela pesquisa de percepção
        da sua empresa junto às comunidades?
      </p>
      <Stack direction="row" spacing={4} sx={{ display: 'inline-block' , m:2}}>
        <Checkbox
          field="indicadorConfianca"
          schema={schema}
          useFormRef={useFormRef}
          disabled={disabledFeqPerc()}
        />
        <Checkbox
          field="indicadorFavorabilidade"
          schema={schema}
          useFormRef={useFormRef}
          disabled={disabledFeqPerc()}
        />
        <Checkbox
          field="indicadorImagem"
          schema={schema}
          useFormRef={useFormRef}
          disabled={disabledFeqPerc()}
        />
        <Checkbox
          field="indicadorLicenca"
          schema={schema}
          useFormRef={useFormRef}
          disabled={disabledFeqPerc()}
        />
        <Checkbox
          field="indicadorReputacao"
          schema={schema}
          useFormRef={useFormRef}
          disabled={disabledFeqPerc()}
        />
        <Checkbox
          field="indicadorSatisfacao"
          schema={schema}
          useFormRef={useFormRef}
          disabled={disabledFeqPerc()}
        />
        <Stack direction="row" spacing={2} sx={{display: 'inline-block'}}>
        <Typography sx={{ display: 'inline-block', py:1}}>Outro</Typography>
          <TextField
            sx={{ width: 200}}
            field="indicadorOutro"
            schema={schema}
            useFormRef={useFormRef}
            size="small"
            disabled={disabledFeqPerc()}
          />
        </Stack>
      </Stack>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        '& .MuiTypography-root': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>
        <Grid
          size={{
            md: 7
          }}>
        <Typography>
          Como foi o último resultado da pesquisa de percepção da sua empresa
          junto às comunidades?
        </Typography>
        </Grid>
        <Grid
          size={{
            md: 5
          }}>
          <FormControl fullWidth>
          <Autocomplete
            field="resultadoPesqPercep"
            options={optionsResultPercep}
            schema={schema}
            useFormRef={useFormRef}
            disabled={disabledFeqPerc()}
          />
          </FormControl>
        </Grid>
      </Grid>
      <Divider sx={{mt:3}}>
        <h3>Temas Prioritários</h3>
      </Divider>
      <FormControl sx={{ my: 2, textAlign:'left' }}>
        <Checkbox
          field="mapeamentoTemas"
          schema={schema}
          useFormRef={useFormRef}
        />
        <Typography sx={{textAlign: 'left', mt:3,mb:1}}>
          Qual a metodologia utilizada pela sua empresa para definição dos temas
          prioritários para as comunidades na área de atuação da sua empresa?
        </Typography>
        <TextField
          field="temaMetodolUtilizadas"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          disabled={disabledMapeaTemas()}
          inputProps={{ maxLength: 1000 }}
        />
        <Grid container spacing={2} sx={{
          alignItems: 'center',
          my:2,
          '& .MuiTypography-root': { textAlign: 'right' },
          '& .MuiGrid-root': { p: 1 },
        }}>
          <Grid
            size={{
              md: 7
            }}>
          <Typography>Como se dá o processo para definição dos temas prioritários?</Typography>
          </Grid>
          <Grid
            size={{
              md: 5
            }}>

          <Autocomplete
            field="definicaoTemas"
            options={optionsDefTemas}
            schema={schema}
            useFormRef={useFormRef}
            disabled={disabledMapeaTemas()}
            />
          </Grid>
        </Grid>
        <p>Liste as consultorias em caso de contratação</p>
        <TextField
          field="consultorias"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          disabled={disabledMapeaTemas() || disabledDefTemas()}
          inputProps={{ maxLength: 1000 }}
        />
        <p>
          <strong>
            Ordene por relevância os temas prioritários para as comunidades na
            área de atuação da sua empresa (da maior para a menor)
          </strong>
        </p>
        <p>
        * Para ordenar os temas, clique e arraste para cima ou para baixo as caixas abaixo.
        </p>
        <OrderList
          field="ordemTemas"
          useFormRef={useFormRef}
          options={optionsTemas}
        />

        <Grid container spacing={2} sx={{
          alignItems: 'center',
          '& .MuiTypography-root': { textAlign: 'right' },
          '& .MuiGrid-root': { p: 1 },
        }}>
          <Grid
            size={{
              md: 7
            }}>
          <Typography>
              Quanto dos temas prioritários para as comunidadessão trabalhados
              pela sua empresa na estratégia de relacionamento com as comunidades?
            </Typography>
          </Grid>
          <Grid
            size={{
              md: 5
            }}>

          <Autocomplete
            field="qntdTemasTrab"
            options={optionsQntdTemasTrab}
            schema={schema}
            useFormRef={useFormRef}
            disabled={disabledMapeaTemas()}
            />
          </Grid>
        </Grid>
      </FormControl>
      <Divider>
        <h3>Indicador de satisfação</h3>
      </Divider>
      <FormControl sx={{ m: 1 }} fullWidth>
        <Checkbox
          field="ferramentaMensurarSatisf"
          schema={schema}
          useFormRef={useFormRef}
        />
        <br></br>
        <TextField
          field="ferramentaDetalhamento"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          disabled={disabledMensuraSatisf()}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      {/* Plano Fechamento Mina */}
      <Divider sx={{mt:3}}/>
      <FormControl sx={{ m: 1 }} fullWidth>
        <Checkbox
          field="planoFechamentoMina"
          schema={schema}
          useFormRef={useFormRef}
        />
        <br></br>
        <TextField
          field="planoFechamentoMinaComent"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          disabled={disabledPlanoFechMinaComent()}
          inputProps={{ maxLength: 1000 }}
        />
      {/* Estágio Plano Fechamento Mina */}
        <Grid container spacing={2} sx={{
          alignItems: 'center',
          my:2,
          '& .MuiTypography-root': { textAlign: 'right' },
          '& .MuiGrid-root': { p: 1 },
        }}>
          <Grid
            size={{
              md: 7
            }}>
            <Typography>Em que estágio se encontra o Plano de Fechamento de Mina (PFM)?</Typography>
          </Grid>
          <Grid
            size={{
              md: 5
            }}>

            <Autocomplete
              field="estagioPlanoFechamento"
              options={optionsEstagioPlano}
              schema={schema}
              useFormRef={useFormRef}
              disabled={disabledPlanoFechMinaComent()}
              />
          </Grid>
        </Grid>
        <TextField
          field="metodologiaEstagioPlano"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          disabled={disabledPlanoFechMinaComent()}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      {/* Final Formulario */}
      <Divider sx={{mt:3}}>
        <h3>Observações</h3>
      </Divider>
      <FormControl sx={{ m: 1 }} fullWidth>
        <TextField
          field="observacoes"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <Box>
        <Button variant="outlined" sx={{ mr: 2 }}
                onClick={()=>{reset();}} disabled={!isDirty || isSubmitting}>
          CANCELAR
        </Button>
        <Button
          type="submit"
          variant="contained"
          sx={{ m: 1 }}
          onClick={handleSubmit(submit)}
          disabled={!isDirty || isSubmitting}
        >
          Salvar
        </Button>
      </Box>
    </div>)
  );
};

export default Registros;
